import React, { useState } from 'react';
import { Stack, ControlLink } from '@moda/om';
import { useHolidayCutoff } from './useHolidayCutoff';
import { HolidayDelayModal } from './HolidayDelayModal';
import './HolidayDelayContainer.scss';

export const HolidayDelayContainer: React.FC = () => {
  const cutoff = useHolidayCutoff();
  const [show, setShow] = useState(false);

  if (!cutoff) return null;

  return (
    <>
      <Stack
        className="HolidayDelayContainer"
        direction="horizontal"
        space={1}
        justifyContent="center"
      >
        <span>See</span>
        <ControlLink onClick={() => setShow(true)} className="HolidayDelayContainer__link">
          Holiday Shipping Schedule
        </ControlLink>
        <span>For Your Location</span>
      </Stack>
      <HolidayDelayModal show={show} onClose={() => setShow(false)} />
    </>
  );
};
